export const translateStatus = status => {
    switch (status) {
        case 1:
            return 'flow.status.1'

        case 2:
            return 'flow.status.2'

        case 3:
            return 'flow.status.3'

        case 4:
            return 'flow.status.4'

        case 5:
            return 'flow.status.5'

         default:
            return 'flow.status.0'
    }

}



// WEBPACK FOOTER //
// ./src/utils/translate.js